import { all, fork } from 'redux-saga/effects';
import { watchAddPhaseAboveInProjectTemplateSaga } from './add-phase-above';
import { watchCreatePhaseInProjectTemplateSaga } from './create';
import { watchDeletePhaseInProjectTemplateSaga } from './delete';
import { watchAddTemplatePhaseDependencySaga } from './dependency';
import { watchShiftStartDayOfProjectPhaseInProjectTemplateSaga } from './shift-start-day';
import { watchUpdatePhaseInProjectTemplateSaga } from './update';

export function* projectPhaseTemplateRootSaga(): Generator {
  yield all([
    fork(watchCreatePhaseInProjectTemplateSaga),
    fork(watchUpdatePhaseInProjectTemplateSaga),
    fork(watchDeletePhaseInProjectTemplateSaga),
    fork(watchAddPhaseAboveInProjectTemplateSaga),
    fork(watchShiftStartDayOfProjectPhaseInProjectTemplateSaga),
    fork(watchAddTemplatePhaseDependencySaga),
  ]);
}
